// Final donation figures for Adventures for Alopecia.
//
// Donations closed when the organization wound down, and AFA formally dissolved in July 2023.
// The live donation backend (AWS Lambda + Google Sheets) has been retired, so these values are
// fixed here instead of being fetched at runtime.
//
// $34,449 is the figure published in the August 2023 final report and shown on the site since then
// (it sums each donation rounded down to the dollar). The exact total is $34,456.48 across 144 donations.
export const FINAL_DONATION_TOTAL = '34,449' // USD, formatted for display
export const FINAL_DONATION_COUNT = 144
